<footer>
  @if (systemParamsService.getLogo()()){
    <img
      [src]="systemParamsService.getLogo()()"
      alt="department logo"
      class="logo"/>
  } @else {
    <img ngSrc="./assets/light-logo.png" alt="department logo" class="logo" height="100" width="300" priority>
  }
  <p>Copyright &copy; 2024 Australian Government - {{ systemParamsService.getName()() }} @if(environment() !== 'prd' ){(<span
    class="environment">{{ environment() }}</span>)} </p>
</footer>

